import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Btn, Input, Modal } from "@/components/erp/ui";

// Tambah supplier langsung dari form lain; nama / HP / email yang sama ditolak backend
export const QuickSupplier = ({ onAdded }) => {
  const [f, setF] = useState(null);
  const save = async () => {
    try { const { data } = await api.post("/suppliers", f); toast.success("Supplier ditambahkan"); setF(null); onAdded?.(data); }
    catch (e) { toast.error(e?.response?.data?.detail || "Gagal menambah supplier"); }
  };
  return (<>
    <button type="button" data-testid="quick-supplier-open" className="text-[11px] text-sky-700 underline ml-1" onClick={() => setF({ name: "", phone: "", email: "", contact: "", address: "", notes: "" })}>+ supplier baru</button>
    {f && <Modal open onClose={() => setF(null)} title="Supplier baru" footer={<><Btn variant="ghost" onClick={() => setF(null)}>Batal</Btn><Btn data-testid="quick-supplier-save" disabled={!f.name.trim()} onClick={save}>Simpan</Btn></>}>
      <div className="space-y-2">
        <Input data-testid="quick-supplier-name" placeholder="Nama supplier *" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
        <Input data-testid="quick-supplier-phone" placeholder="Nomor HP / WA" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} />
        <Input data-testid="quick-supplier-email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
        <p className="text-[11px] text-slate-500">Kalau nama, nomor HP, atau email sama dengan supplier yang sudah ada, tidak bisa dibuat.</p>
      </div>
    </Modal>}
  </>);
};
